import React from 'react';
import clsx from 'clsx';
import { ViewArchiveInfo } from "./view-archive-info.component";
import '@isyc-react/design/main';
import "./view-archive-status.style.scss";
export const ViewArchiveInfoError = props => {
  const {
    className,
    children
  } = props;
  return /*#__PURE__*/React.createElement(ViewArchiveInfo, {
    className: clsx('flex-column', className)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-close font-size-90 text-secondary"
  }), children);
};